import '@tiptap/core';
import '@tiptap/pm/model';
import 'lodash';
import 'ricos-content';

var getAlignmentFromDirection = function getAlignmentFromDirection(direction) {
  return direction.toLowerCase() === "rtl" ? "right" : direction.toLowerCase() === "ltr" ? "left" : void 0;
};

export { getAlignmentFromDirection as g };

import 'wix-rich-content-plugin-collapsible-list/dist/loadable/viewer/es/styles.viewer.min.global.css'